<bit-side-nav [variant]="variant()">
  <ng-content></ng-content>
</bit-side-nav>
